import { graphql } from '@apollo/client/react/hoc'

import { ApplicationError, NotFoundError } from '../../helpers/errors'
import { localISODate } from '../../helpers/date-helpers'
import query from './query.graphql'

export { query }

export const mapPropsToOptions = ({ id, centre }) => ({
  context: { version: 1 },
  variables: {
    id,
    startsAt: localISODate(centre.timeZone),
  },
  errorPolicy: 'ignore',
})

export const mapDataToProps = ({
  ownProps: { centre, id, slug },
  data: { service, loading, error },
}) => {
  if (error) {
    return {
      error: new ApplicationError(error),
    }
  } else if (loading) {
    return { loading }
  } else if (!service) {
    return {
      error: new NotFoundError(),
    }
  } else if (service.category === 'Parking') {
    return { redirect: `/${centre.slug}/parking` }
  } else if (slug !== service.slug) {
    return { redirect: `/${centre.slug}/service/${id}/${service.slug}` }
  } else if (service.centre.slug !== centre.slug) {
    return { redirect: `/${centre.slug}` }
  }

  return {
    entry: {
      category: 'Service',
      title: service.title,
      shortDescription: service.shortDescription,
      body: service.bodyCopy,
      centre: service.centre,
      analyticsMetadata: service.analyticsMetadata,
    },
  }
}

const withServiceDetail = graphql(query, {
  options: mapPropsToOptions,
  props: mapDataToProps,
})

export default withServiceDetail
